import * as React from 'react';



export default class Emptyfile extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="294" height="188" viewBox="0 0 294 188" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
        <defs>
        <linearGradient id="files__b" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F3F6F7"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__d" x1="0%" x2="100%" y1="10.316%" y2="82.766%">
            <stop offset="0%" stopColor="#EA8B8B" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__f" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F3F6F7"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__i" x1="29.839%" x2="70.161%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__l" x1="38.2%" x2="61.8%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__o" x1="41.094%" x2="58.906%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__r" x1="29.847%" x2="70.153%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__u" x1="38.202%" x2="61.798%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__x" x1="42.411%" x2="57.589%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__A" x1="40.312%" x2="59.688%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#F3C7A6" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__D" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F3F6F7"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__G" x1="0%" x2="100%" y1="-10.556%" y2="100%">
            <stop offset="0%" stopColor="#A0E2AB" stopOpacity=".457"/>
            <stop offset="100%" stopColor="#A0E2AB" stopOpacity=".126"/>
        </linearGradient>
        <linearGradient id="files__J" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F6F8F9"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__M" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F3F6F7"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__P" x1="100%" x2="0%" y1="50%" y2="50%">
            <stop offset="0%" stopColor="#B6DCF5"/>
            <stop offset="100%" stopColor="#B6DCF5" stopOpacity=".09"/>
        </linearGradient>
        <linearGradient id="files__S" x1="100%" x2="0%" y1="50%" y2="50%">
            <stop offset="0%" stopColor="#B6DCF5"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__V" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#F3F6F7"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__X" x1="0%" x2="100%" y1="49.627%" y2="50.308%">
            <stop offset="0%" stopColor="#DDDCFF" stopOpacity=".462"/>
            <stop offset="100%" stopColor="#DDDCFF" stopOpacity=".288"/>
        </linearGradient>
        <linearGradient id="files__Y" x1="0%" x2="100%" y1="49.722%" y2="50.23%">
            <stop offset="0%" stopColor="#DDDCFF" stopOpacity=".462"/>
            <stop offset="100%" stopColor="#DDDCFF" stopOpacity=".288"/>
        </linearGradient>
        <linearGradient id="files__Z" x1="0%" x2="100%" y1="49.522%" y2="50.395%">
            <stop offset="0%" stopColor="#DDDCFF" stopOpacity=".462"/>
            <stop offset="100%" stopColor="#DDDCFF" stopOpacity=".288"/>
        </linearGradient>
        <linearGradient id="files__ab" x1="0%" x2="100%" y1="49.613%" y2="50.32%">
            <stop offset="0%" stopColor="#DDDCFF" stopOpacity=".462"/>
            <stop offset="100%" stopColor="#DDDCFF" stopOpacity=".288"/>
        </linearGradient>
        <linearGradient id="files__ae" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#E8ECEE"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__ag" x1="73.11%" x2="30.368%" y1="70.474%" y2="30.547%">
            <stop offset="0%" stopColor="#FDF9F9"/>
            <stop offset="100%" stopColor="#EBEFF1"/>
        </linearGradient>
        <linearGradient id="files__ai" x1="50%" x2="50%" y1="0%" y2="96.323%">
            <stop offset="0%" stopColor="#ECEFF1"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <linearGradient id="files__al" x1="50%" x2="50%" y1="0%" y2="150.52%">
            <stop offset="0%" stopColor="#E8ECEE"/>
            <stop offset="100%" stopColor="#FFF"/>
        </linearGradient>
        <path id="files__a" d="M19.73 1.489L.447 75.832c-.182.703.242 1.42.948 1.602L60.463 92.6c.707.182 1.427-.24 1.61-.944L79.33 25.115l-6.818-11.429L21.34.545c-.111-.029-.223-.042-.332-.042-.588 0-1.124.393-1.278.986"/>
        <path id="files__e" d="M31.877 1.69L.852 79.803c-.294.737.075 1.57.823 1.86l62.584 24.202c.748.29 1.593-.074 1.885-.813l27.77-69.914-5.928-13.29L33.763.876c-.174-.067-.354-.1-.53-.1-.582 0-1.13.347-1.356.914"/>
        <path id="files__h" d="M1.413.972L.172 4.362c-.125.342.033.727.351.861l.704.295c.319.134.679-.034.803-.375l1.24-3.39c.126-.342-.032-.728-.35-.862L2.216.596C2.142.565 2.065.549 1.99.549c-.248.001-.482.16-.577.423"/>
        <path id="files__k" d="M4.559.895L.099 12.272c-.167.425.043.904.468 1.07l.268.106c.426.165.904-.043 1.071-.468l4.46-11.377c.166-.424-.043-.904-.469-1.071L5.63.428C5.53.388 5.428.37 5.328.37c-.33 0-.642.2-.77.525"/>
        <path id="files__n" d="M6.992.609L.291 19.023c-.165.455.043.97.465 1.148l.212.09c.423.178.9-.047 1.065-.502l6.7-18.414C8.9.89 8.693.375 8.27.198l-.212-.09c-.098-.041-.2-.061-.299-.061-.329 0-.639.213-.766.562"/>
        <path id="files__q" d="M1.547 1.087l-1.24 3.39c-.125.343.032.728.35.861l.705.296c.319.134.678-.034.803-.376l1.24-3.39c.125-.341-.032-.727-.35-.862L2.35.711C2.276.68 2.2.665 2.124.665c-.247 0-.48.16-.577.422"/>
        <path id="files__t" d="M4.683 1.229L.224 12.605c-.166.425.044.905.468 1.071l.268.105c.425.166.905-.042 1.07-.467L6.49 1.937c.166-.425-.043-.904-.468-1.071L5.754.76c-.099-.04-.2-.057-.301-.057-.33 0-.642.199-.77.525"/>
        <path id="files__w" d="M6.758.65L.573 19.064c-.155.455.038.97.429 1.147l.194.09c.39.178.831-.046.984-.501L8.366 1.386c.153-.456-.04-.97-.43-1.147L7.74.15C7.65.107 7.557.087 7.464.087c-.303 0-.59.214-.706.563"/>
        <path id="files__z" d="M10.79 1.14L.794 26.374c-.175.44.045.939.492 1.112l.161.063c.446.173.95-.045 1.124-.487L12.566 1.83c.174-.441-.046-.94-.492-1.112l-.16-.062c-.105-.04-.212-.06-.317-.06-.347 0-.674.207-.808.545"/>
        <path id="files__C" d="M1.322 13.4c-.853.181-1.395 1.01-1.211 1.852l19.428 89.034c.184.842 1.024 1.377 1.877 1.195L92.75 90.327c.854-.182 1.395-1.01 1.212-1.852L76.572 8.784 63.128.27 1.322 13.4z"/>
        <path id="files__F" d="M12.348.724C4.17 2.486-1.033 10.544.728 18.722c1.76 8.179 9.818 13.381 17.998 11.62 8.178-1.76 13.381-9.818 11.62-17.998C28.816 5.24 22.536.381 15.552.382c-1.056 0-2.13.11-3.204.342"/>
        <path id="files__I" d="M2.055 10.857L8.344 3.978 0.118 0.647z"/>
        <path id="files__L" d="M35.476 1.161L.343 39.497c-.484.529-.452 1.352.075 1.84l55.671 51.568c.526.488 1.346.454 1.83-.076l40.552-44.247c.484-.528.451-1.352-.075-1.84L48.567.586l-13.091.575z"/>
        <path id="files__O" d="M11.516 18.599L0.461 18.49 2.24 34.449 5.614 37.542 34.306 6.548 28.87 1.563 9.523 0.538z"/>
        <path id="files__R" d="M1.416 1.568c-1.593 1.729-1.483 4.423.246 6.016 1.73 1.593 4.423 1.483 6.016-.246 1.594-1.73 1.484-4.423-.246-6.016C6.614.568 5.58.195 4.548.195 3.4.195 2.255.657 1.416 1.568"/>
        <path id="files__U" d="M2.326.038c-.95 0-1.72.774-1.72 1.731v101.134c0 .956.77 1.731 1.72 1.731h79.36c.949 0 1.718-.775 1.718-1.73V12.381L71.083.038H2.326z"/>
        <path id="files__aa" d="M0.279 0.376L52.722 0.376 52.722 4.569 0.279 4.569z"/>
        <path id="files__ad" d="M0.968 10.308L0.399 22.271 34.998 8.285 26.235 0.094z"/>
        <path id="files__ah" d="M251.297 98.872C237.765 42.284 186.58.195 125.507.195 65.21.195 14.554 41.22.253 96.72"/>
        <path id="files__ak" d="M0.169 5.651L22.471 14.651 22.105 6.954 5.818 0.38z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g transform="translate(171 17)">
            <mask id="files__c" fill="#fff">
                <use xlinkHref="#files__a"/>
            </mask>
            <path fill="url(#files__b)" d="M19.73 1.489L.447 75.832c-.182.703.242 1.42.948 1.602L60.463 92.6c.707.182 1.427-.24 1.61-.944L79.33 25.115l-6.818-11.429L21.34.545c-.111-.029-.223-.042-.332-.042-.588 0-1.124.393-1.278.986" mask="url(#files__c)"/>
        </g>
        <path fill="url(#files__d)" fillRule="nonzero" d="M212.936 66.402c-.378-.931-.731-1.917-1.06-2.955-.339-1.07-.65-2.22-.928-3.398-1.292 1.915-2.788 3.797-4.466 5.644l-.351.383c2.208-.036 4.498.076 6.805.326zm-3.51-19.526c.243-1.182.886-2.426 1.904-3.139 2.307-1.615 5.388-.476 5.06 2.445-.534 4.773-2.436 9.409-5.442 13.867-1.278-5.394-1.888-11.382-1.521-13.173zm11.547 20.947c4.198 1.038 7.472 2.382 8.937 3.742 2.356 2.185.72 4.212-3.258 4.946-6.233 1.15-10.745-2.79-13.716-10.109 2.692.292 5.406.77 8.037 1.421zm-27.046 8.623c-2.798 1.877-6.188-1.382-4.455-4.273.03-.052.063-.104.088-.144.932-1.491 2.32-2.682 3.987-3.483 3.338-1.604 7.764-2.39 12.584-2.47-3.802 4.112-8.088 7.606-12.204 10.37zm5.756-7.381c-1.917.368-3.653.902-5.129 1.611-1.28.615-2.326 1.513-3.02 2.622l-.052.086c-.444.74.43 1.58 1.147 1.098 2.335-1.568 4.732-3.383 7.054-5.417zm5.072-4.965c3.21-3.533 5.7-7.18 7.315-10.902.413 3.246 1.096 6.56 2.037 9.532.838 2.643 1.821 4.88 2.955 6.662-6.079-1.125-12.35-1.294-17.38-.327 1.753-1.535 3.463-3.194 5.073-4.965zm21.475 10.09c1.178-.217 1.941-.49 2.264-.715-.041-.048-.097-.107-.17-.175-1.094-1.014-4.07-2.236-7.909-3.185-1.105-.273-2.225-.515-3.353-.723 2.383 3.745 5.428 5.488 9.168 4.798zm-12.167-28.273c.068-.601-.555-.831-1.396-.242-.44.307-.815 1.033-.947 1.678-.036.176-.05.832-.015 1.702.042 1.049.146 2.322.308 3.68l.057.463c1.041-2.399 1.719-4.83 1.993-7.28z"/>
        <g transform="translate(201 54)">
            <mask id="files__g" fill="#fff">
                <use xlinkHref="#files__e"/>
            </mask>
            <path fill="url(#files__f)" d="M31.877 1.69L.852 79.803c-.294.737.075 1.57.823 1.86l62.584 24.202c.748.29 1.593-.074 1.885-.813l27.77-69.914-5.928-13.29L33.763.876c-.174-.067-.354-.1-.53-.1-.582 0-1.13.347-1.356.914" mask="url(#files__g)"/>
        </g>
        <g transform="translate(232 99)">
            <mask id="files__j" fill="#fff">
                <use xlinkHref="#files__h"/>
            </mask>
            <path fill="url(#files__i)" d="M1.413.972L.172 4.362c-.125.342.033.727.351.861l.704.295c.319.134.679-.034.803-.375l1.24-3.39c.126-.342-.032-.728-.35-.862L2.216.596C2.142.565 2.065.549 1.99.549c-.248.001-.482.16-.577.423" mask="url(#files__j)"/>
        </g>
        <g transform="translate(235 96)">
            <mask id="files__m" fill="#fff">
                <use xlinkHref="#files__k"/>
            </mask>
            <path fill="url(#files__l)" d="M4.559.895L.099 12.272c-.167.425.043.904.468 1.07l.268.106c.426.165.904-.043 1.071-.468l4.46-11.377c.166-.424-.043-.904-.469-1.071L5.63.428C5.53.388 5.428.37 5.328.37c-.33 0-.642.2-.77.525" mask="url(#files__m)"/>
        </g>
        <g transform="translate(239 95)">
            <mask id="files__p" fill="#fff">
                <use xlinkHref="#files__n"/>
            </mask>
            <path fill="url(#files__o)" d="M6.992.609L.291 19.023c-.165.455.043.97.465 1.148l.212.09c.423.178.9-.047 1.065-.502l6.7-18.414C8.9.89 8.693.375 8.27.198l-.212-.09c-.098-.041-.2-.061-.299-.061-.329 0-.639.213-.766.562" mask="url(#files__p)"/>
        </g>
        <g transform="translate(264 111)">
            <mask id="files__s" fill="#fff">
                <use xlinkHref="#files__q"/>
            </mask>
            <path fill="url(#files__r)" d="M1.547 1.087l-1.24 3.39c-.125.343.032.728.35.861l.705.296c.319.134.678-.034.803-.376l1.24-3.39c.125-.341-.032-.727-.35-.862L2.35.711C2.276.68 2.2.665 2.124.665c-.247 0-.48.16-.577.422" mask="url(#files__s)"/>
        </g>
        <g transform="translate(258 104)">
            <mask id="files__v" fill="#fff">
                <use xlinkHref="#files__t"/>
            </mask>
            <path fill="url(#files__u)" d="M4.683 1.229L.224 12.605c-.166.425.044.905.468 1.071l.268.105c.425.166.905-.042 1.07-.467L6.49 1.937c.166-.425-.043-.904-.468-1.071L5.754.76c-.099-.04-.2-.057-.301-.057-.33 0-.642.199-.77.525" mask="url(#files__v)"/>
        </g>
        <g transform="translate(251 99)">
            <mask id="files__y" fill="#fff">
                <use xlinkHref="#files__w"/>
            </mask>
            <path fill="url(#files__x)" d="M6.758.65L.573 19.064c-.155.455.038.97.429 1.147l.194.09c.39.178.831-.046.984-.501L8.366 1.386c.153-.456-.04-.97-.43-1.147L7.74.15C7.65.107 7.557.087 7.464.087c-.303 0-.59.214-.706.563" mask="url(#files__y)"/>
        </g>
        <g transform="translate(243 93)">
            <mask id="files__B" fill="#fff">
                <use xlinkHref="#files__z"/>
            </mask>
            <path fill="url(#files__A)" d="M10.79 1.14L.794 26.374c-.175.44.045.939.492 1.112l.161.063c.446.173.95-.045 1.124-.487L12.566 1.83c.174-.441-.046-.94-.492-1.112l-.16-.062c-.105-.04-.212-.06-.317-.06-.347 0-.674.207-.808.545" mask="url(#files__B)"/>
        </g>
        <g transform="translate(41 15)">
            <mask id="files__E" fill="#fff">
                <use xlinkHref="#files__C"/>
            </mask>
            <path fill="url(#files__D)" d="M1.322 13.4c-.853.181-1.395 1.01-1.211 1.852l19.428 89.034c.184.842 1.024 1.377 1.877 1.195L92.75 90.327c.854-.182 1.395-1.01 1.212-1.852L76.572 8.784 63.128.27 1.322 13.4z" mask="url(#files__E)"/>
        </g>
        <g transform="translate(73 52)">
            <mask id="files__H" fill="#fff">
                <use xlinkHref="#files__F"/>
            </mask>
            <path fill="url(#files__G)" d="M12.348.724C4.17 2.486-1.033 10.544.728 18.722c1.76 8.179 9.818 13.381 17.998 11.62 8.178-1.76 13.381-9.818 11.62-17.998C28.816 5.24 22.536.381 15.552.382c-1.056 0-2.13.11-3.204.342" mask="url(#files__H)"/>
        </g>
        <g transform="translate(85 63)">
            <mask id="files__K" fill="#fff">
                <use xlinkHref="#files__I"/>
            </mask>
            <path fill="url(#files__J)" d="M3.055 10.857L9.344 3.978 1.118 0.647z" mask="url(#files__K)"/>
        </g>
        <g transform="translate(0 66)">
            <mask id="files__N" fill="#fff">
                <use xlinkHref="#files__L"/>
            </mask>
            <path fill="url(#files__M)" d="M35.476 1.161L.343 39.497c-.484.529-.452 1.352.075 1.84l55.671 51.568c.526.488 1.346.454 1.83-.076l40.552-44.247c.484-.528.451-1.352-.075-1.84L48.567.586l-13.091.575z" mask="url(#files__N)"/>
        </g>
        <g transform="translate(41 99)">
            <mask id="files__Q" fill="#fff">
                <use xlinkHref="#files__O"/>
            </mask>
            <path fill="url(#files__P)" d="M11.516 18.599L0.461 18.49 2.24 34.449 5.614 37.542 34.306 6.548 28.87 1.563 9.523 0.538z" mask="url(#files__Q)"/>
        </g>
        <g transform="translate(27 100)">
            <mask id="files__T" fill="#fff">
                <use xlinkHref="#files__R"/>
            </mask>
            <path fill="url(#files__S)" d="M1.416 1.568c-1.593 1.729-1.483 4.423.246 6.016 1.73 1.593 4.423 1.483 6.016-.246 1.594-1.73 1.484-4.423-.246-6.016C6.614.568 5.58.195 4.548.195 3.4.195 2.255.657 1.416 1.568" mask="url(#files__T)"/>
        </g>
        <g transform="translate(109)">
            <mask id="files__W" fill="#fff">
                <use xlinkHref="#files__U"/>
            </mask>
            <path fill="url(#files__V)" d="M2.326.038c-.95 0-1.72.774-1.72 1.731v101.134c0 .956.77 1.731 1.72 1.731h79.36c.949 0 1.718-.775 1.718-1.73V12.381L71.083.038H2.326z" mask="url(#files__W)"/>
        </g>
        <path fill="url(#files__X)" d="M122 19L173 19 173 15 122 15z"/>
        <path fill="url(#files__Y)" d="M122 36L181 36 181 32 122 32z"/>
        <path fill="url(#files__Z)" d="M122 49L167 49 167 45 122 45z"/>
        <g transform="translate(122 57)">
            <mask id="files__ac" fill="#fff">
                <use xlinkHref="#files__aa"/>
            </mask>
            <path fill="url(#files__ab)" d="M0.279 4.569L52.722 4.569 52.722 0.376 0.279 0.376z" mask="url(#files__ac)"/>
        </g>
        <g>
            <g transform="translate(24.169 74.38) translate(66.831 .62)">
                <mask id="files__af" fill="#fff">
                    <use xlinkHref="#files__ad"/>
                </mask>
                <path fill="url(#files__ae)" d="M0.968 10.308L0.399 22.271 34.998 8.285 26.235 0.094z" mask="url(#files__af)"/>
            </g>
            <path fill="url(#files__ag)" d="M165 12.271L187.302 21.271 186.936 13.574 170.649 7z" transform="translate(24.169 74.38)"/>
            <g transform="translate(24.169 74.38) translate(.831 5.62)">
                <mask id="files__aj" fill="#fff">
                    <use xlinkHref="#files__ah"/>
                </mask>
                <path fill="url(#files__ai)" d="M251.294 98.863c-1.852-7.742-4.408-15.213-7.599-22.341C223.568 31.55 178.222.195 125.507.195c-51.86 0-96.589 30.348-117.19 74.152C4.856 81.709 2.076 89.45.058 97.493" mask="url(#files__aj)"/>
                <path fill="#F2F5F7" d="M129.33 53.562c0 1.59-2.803 2.878-6.26 2.878s-6.26-1.288-6.26-2.878 2.803-2.878 6.26-2.878 6.26 1.289 6.26 2.878" mask="url(#files__aj)"/>
                <g>
                    <path fill="#EBEDEF" d="M88.163 5.594c0 2.726-7.536 4.936-16.834 4.936-9.297 0-16.833-2.21-16.833-4.936S62.032.658 71.33.658c9.298 0 16.834 2.21 16.834 4.936" transform="translate(55 11)"/>
                    <path fill="#F0F2F4" d="M33.792 30.983c0 4.274-7.536 7.74-16.834 7.74-9.296 0-16.833-3.466-16.833-7.74s7.537-7.74 16.833-7.74c9.298 0 16.834 3.466 16.834 7.74" transform="translate(55 11)"/>
                    <path fill="#F8F9F9" d="M71.33 48.562c0 1.59-2.803 2.878-6.26 2.878s-6.26-1.288-6.26-2.878 2.803-2.878 6.26-2.878 6.26 1.289 6.26 2.878" transform="translate(55 11)"/>
                    <path fill="#F8FAFB" d="M88.163 75.774c0 1.59-2.802 2.878-6.259 2.878-3.457 0-6.26-1.288-6.26-2.878s2.803-2.878 6.26-2.878 6.259 1.289 6.259 2.878" transform="translate(55 11)"/>
                    <path fill="#F0F2F4" d="M125.888 30.128c0 2.706-4.773 4.9-10.66 4.9-5.886 0-10.658-2.194-10.658-4.9 0-2.707 4.772-4.9 10.658-4.9 5.887 0 10.66 2.193 10.66 4.9" transform="translate(55 11)"/>
                    <path fill="#F8FAFB" d="M144.965 66.36c0 4.076-7.187 7.38-16.053 7.38-8.867 0-16.054-3.304-16.054-7.38 0-4.075 7.187-7.38 16.054-7.38 8.866 0 16.053 3.305 16.053 7.38M33.792 70.848c0 2.72-4.798 4.926-10.716 4.926-5.92 0-10.717-2.206-10.717-4.926 0-2.721 4.798-4.928 10.717-4.928 5.918 0 10.716 2.207 10.716 4.928" transform="translate(55 11)"/>
                </g>
            </g>
        </g>
        <g transform="translate(189 81)">
            <use fill="url(#files__al)" xlinkHref="#files__ak"/>
        </g>
    </g>
        </svg>
    )
  }
}
